import axios from 'axios';

// Create axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  timeout: 10000,
});

// Request interceptor to add auth token and visitor ID
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Add visitor ID to all requests
    const visitorId = localStorage.getItem('visitorId');
    if (visitorId) {
      config.headers['X-Visitor-ID'] = visitorId;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 responses
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Clear token and redirect to login
      localStorage.removeItem('authToken');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// Metrics API functions
export const metricsApi = {
  // Get metrics for a specific product
  getProductMetrics: (productId, params = {}) => {
    return api.get(`/api/metrics/product/${productId}`, { params });
  },

  // Get latest metric for a product
  getLatestProductMetric: (productId) => {
    return api.get(`/api/metrics/product/${productId}/latest`);
  },

  // Get metrics for a user
  getUserMetrics: (userId, params = {}) => {
    return api.get(`/api/metrics/user/${userId}`, { params });
  },

  // Get analytics data
  getAnalytics: (params = {}) => {
    return api.get('/api/metrics/analytics', { params });
  },

  // Get basic statistics
  getStats: (params = {}) => {
    return api.get('/api/metrics/stats', { params });
  },

  // Add custom metric
  addCustomMetric: (metricId, data) => {
    return api.post(`/api/metrics/custom/${metricId}`, data);
  },

  // Cleanup old metrics
  cleanupOldMetrics: (params = {}) => {
    return api.delete('/api/metrics/cleanup', { params });
  }
};

export default api;

